import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d50ad27"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "order-status fw600" }
const _hoisted_3 = { class: "status-tips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy",
  id: "copyItem"
}, "复制", -1))
const _hoisted_5 = {
  key: 0,
  class: "xag-ellipsis",
  style: {"color":"rgba(0, 0, 0, 0.22)"}
}
const _hoisted_6 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_7 = {
  key: 0,
  class: "tips-wrap"
}
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "button-wrap xag-flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useAppPay } from '@/compositions/usePay'
import { useClipboard } from '@/compositions/common'
import { Toast, PullRefresh, Button, Dialog } from 'vant'
import { useOrderApply } from '@/compositions/invoice/index'
import { commonErrorHandle, getErrorMessage } from '@/utils/error-handle'
import { judgeIsFuselageInsurance, isAuthWarehouse, NO } from '@/defination/malfunction-repair'
import { ref, Ref, computed, ComputedRef, onMounted, onActivated } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { MalfunctionRepairOrderDetailStorage } from '@/storage/malfunction-repair'
import {
  ConfirmPayOrderResult,
  ConfirmPayOrderPrams,
  MalfunctionRepairRepairOrderDetail,
  MalfunctionRepairRepairOrderQualitativeInfo,
  MalfunctionRepairRepairOrderQualitativeInfoFront,
} from '@/types/malfunction-repair'
import {
  getRepairOrderDetail,
  confirmOrderRepair,
  confirmPayRepairOrder,
  checkRepairOrderPayStatus,
  submitRepairOrderInvoiceInfo,
  getRepairOrderQualitativeInfo,
} from '@/apis/malfunction-repair'
import {
  showToastLoading,
  showToastSuccess,
  showConfirmModal,
  clearToast,
  showNormalToast,
} from '@/utils/tools'
import wx from 'weixin-js-sdk'
import AppHeader from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import BehalfPay from '@/components/pay/behalf-pay.vue'
import OrderInoviceApply from '@/components/invoice/order-inovice-apply.vue'
import RepairBillBlock from './components/repair-order/detail-bill-block.vue'
import ServiceInfoBlock from './components/repair-order/detail-serivce-info-block.vue'
import RepairPartsBlock from './components/repair-order/detail-repair-parts-block.vue'

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'malfunction-repair-repair-order-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const $store = useStore()
const isMiniProgram = computed(() => {
  return $store.getters.isMiniProgram
})
let timeId: number
const guid = $route.query.guid as string
const serviceGuid = $route.query.serviceGuid as string
const serviceNo = $route.query.serviceNo as string
const isInited = ref(false)
const refreshing = ref(false)
const behalfPayDialogVisible = ref(false)
const confirmPayInfo: Ref<ConfirmPayOrderResult | null> = ref(null)
const confirmPayParams: Ref<ConfirmPayOrderPrams | null> = ref(null)
// let isShowClaims = ref(false)
let detail: Ref<
  | null
  | (MalfunctionRepairRepairOrderDetail & {
      repair_status_color?: string
    })
> = ref(null)
const { initClipboard } = useClipboard({
  text: () => detail.value?.repair_sn,
})
const {
  invoiceData,
  scrollToInvoiceDom,
  invoiceDomInit,
  changeHandle: invoiceChangeHandle,
  verify: invoiceVerify,
  getOrderInvocieSubmitParams,
} = useOrderApply()
const qualitativeInfo: Ref<null | MalfunctionRepairRepairOrderQualitativeInfoFront> = ref(null)
const {
  addOrderRepairDetailItemKeepAlive,
  removeOrderRepairDetailItemKeepAlive,
  removeServiceOrderKeepAlive,
  removeFaultOrderListItemKeepAlive,
} = useMalfunctionRepairStore()
const { compatibleWechatAndCmdPay, judgeCanUseMiniProgramPay } = useAppPay()

const canConfirmRepair = computed(() => {
  return detail.value?.action?.confirmPayOrder || false
})
const isShowClaims = computed(() => {
  if (!detail.value) {
    return false
  }
  return ['5', '11'].includes(detail.value.repair_status) && detail.value.is_pingan
})
const canPay = computed(() => {
  return detail.value?.action?.pay || false
})
const canShowPayBlock = computed(() => {
  let bool = true
  try {
    if (JSON.stringify(detail.value?.pay_order_info) === '{}') {
      // 兼容支付信息是{}的情况
      bool = false
    }
  } catch (error) {
    console.log('error', error)
  }
  return bool
})
// 是否为授权网点单据
const isAuthWarehouseOrder = computed(() => {
  return isAuthWarehouse(detail.value?.repair_warehouse_type)
})
// 是否显示他人代付按钮
const showBehalfBtn = computed(() => {
  // 安心保时需要支付金额不为0
  return (
    canPay.value &&
    !isAuthWarehouseOrder.value &&
    (isFuselageInsurance.value ? detail.value?.pay_order_info?.pay_amount !== 0 : true)
  )
})
// 是否定损后
const isAfterLossAssessment = computed(() => {
  const status = detail.value?.repair_status
  const mainStatus = String(status).split('-')[0]
  return Number(mainStatus) >= 5
})
// 是否为安心保服务
const isFuselageInsurance = computed(() => {
  return judgeIsFuselageInsurance(detail.value?.pay_order_info?.service_type)
})
// 是否有保险服务抵扣
const hasServicePayed = computed(() => {
  const type = detail.value?.pay_order_info?.service_type
  return type && type !== 'NO'
})
// 显示底部按钮
const showFooter: ComputedRef<boolean> = computed(() => {
  return canConfirmRepair.value || canPay.value
})
const behalfStatusCheckHandle: Ref<() => Promise<boolean> | null> = ref(null)
const mateList = computed(() => {
  return detail.value?.pay_order_info?.mateList || []
})
function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkRepairOrderPayStatus(guid)
      .then((result) => {
        if (result) {
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          removeServiceOrderKeepAlive()
          removeFaultOrderListItemKeepAlive()
          setTimeout(() => {
            $router.go(-1)
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
// 支付成功页面
const getCbPageUrl = (): string => {
  return `/malfunction-repair/pay-success/${detail?.value.repair_sn}/${serviceGuid}/${detail?.value.pay_order_info.pay_amount}`
}
async function beforePayHandle(mode: string) {
  if (!isAuthWarehouseOrder.value && detail.value.pay_order_info?.pay_amount && !invoiceVerify()) {
    scrollToInvoiceDom()
    return
  }
  if (isFuselageInsurance.value) {
    try {
      await showConfirmModal({
        title: '提示',
        message: '根据意外机损保险理赔政策，理赔需提供相关资料，资料不完整可能会导致理赔申请失败！',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
        cancelButtonText: '查看理赔资料',
        confirmButtonText: '直接支付',
      })
    } catch (error) {
      toClaimInformation()
      return
    }
  } else {
    try {
      await showConfirmModal({
        title: '提示',
        message: '是否确认支付',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      })
    } catch (error) {
      return
    }
  }

  try {
    confirmPayInfo.value ? '' : await getPayInfoHandle()
    payInfoHandle(mode)
  } catch (error) {
    return
  }
  return true
}
async function getPayInfoHandle() {
  // 获取支付相关信息
  const canUseCmbPay = await judgeCanUseMiniProgramPay()
  try {
    const params = {
      guid,
      from: isMiniProgram.value ? 'applets' : 'app',
      payment_platform: canUseCmbPay ? 'merchants_bank' : 'wechat',
      callback_page_url: window.location.origin + getCbPageUrl(),
    }
    showToastLoading()
    const result = await confirmPayRepairOrder(params)
    clearToast()
    confirmPayInfo.value = result
    confirmPayParams.value = params
  } catch (error) {
    commonErrorHandle(error)
    // 如果获取支付信息失败就刷新页面即可
    // initPageDetail()
    return Promise.reject(error)
  }
}
async function halfPayHandle() {
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (params.from === 'applets') {
    // 小程序支付
    wx.miniProgram.navigateTo({
      url: '/pages/user/pay?guid=' + result.pay_order_no,
    })
  } else {
    //appHost.onPay(result.pay_order_no)
    const userAgree = await compatibleWechatAndCmdPay(result.pay_order_no)
    // 开启轮询
    userAgree && handleSearchOrderPayStatus(result.pay_order_no)
  }
}
function behalfPaySuccessHandle() {
  if (!behalfPayDialogVisible.value) {
    // 如果用户是已经关闭了代付弹窗的状态，不给用户支付成功响应
    return
  }
  behalfPayDialogVisible.value = false
  // 代付支付成功回调
  showToastSuccess('支付成功')
  removeServiceOrderKeepAlive()
  removeFaultOrderListItemKeepAlive()
  setTimeout(() => {
    $router.go(-1)
  }, 2000)
}
async function behalfPayHandle() {
  // 他人代付处理逻辑
  behalfPayDialogVisible.value = true
  behalfStatusCheckHandle.value = async () => {
    try {
      const data = await checkRepairOrderPayStatus(guid)
      return data
    } catch (error) {
      return false
    }
  }
}

function payInfoHandle(mode = 'half') {
  const isBehalf = mode === 'behalf'
  const isHalf = mode === 'half'
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (!result.need_wechat_pay) {
    initPageDetail()
    return
  }
  if (result.pay_type == '线上支付') {
    if (isHalf) {
      // 自己支付时
      halfPayHandle()
    } else if (isBehalf) {
      behalfPayHandle()
    }
    return
  }
  if (result.pay_type == '线下支付') {
    if (result.need_wechat_pay) {
      Toast('错误，线下支付不需要微信支付！')
    } else {
      initPageDetail()
    }
  }
  removeServiceOrderKeepAlive()
}

function toDecection() {
  if (!isAfterLossAssessment.value) {
    return
  }
  addOrderRepairDetailItemKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-detection',
      query: {
        guid,
      },
    })
  }, 50)
}
function toClaimInformation() {
  addOrderRepairDetailItemKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-claim-information',
      query: {
        guid,
        amount: String(detail.value.pay_order_info?.discount_amount || 0),
      },
    })
  }, 50)
}
// 更新维修单发票信息
async function updateInvoiceInfoHandle(): Promise<void> {
  const data = invoiceData.value
  const params = getOrderInvocieSubmitParams()
  try {
    await submitRepairOrderInvoiceInfo(guid, params)
  } catch (error: any) {
    console.log('error', error)
    const message = `发票选择失败: ${getErrorMessage(error)}`
    showNormalToast(message)
  }
  return null
}

async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  try {
    if (invoiceData.value && invoiceData.value?.invoice_guid) {
      await updateInvoiceInfoHandle()
    }
    const promiseList = [getRepairOrderDetail(guid), getRepairOrderQualitativeInfo(guid)]

    let result = await Promise.all(promiseList)
    detail.value = result[0] as MalfunctionRepairRepairOrderDetail
    invoiceChangeHandle(detail.value.invoice_apply)
    //处理付费服务
    let qualitativeInfoResult = result[1] as MalfunctionRepairRepairOrderQualitativeInfo
    qualitativeInfo.value = {
      ...qualitativeInfoResult,
      service_type: [qualitativeInfoResult.service_type],
    }
    if (qualitativeInfo.value.service_type[0] !== NO) {
      qualitativeInfo.value.service_type.push(NO)
    }
    let color = '#F7981C'
    const repairStatus = Number(detail.value.repair_status)
    if (repairStatus === 13) {
      color = '#00C378'
    } else if (repairStatus === 14) {
      color = 'rgba(0,0,0,0.44)'
    }
    detail.value.repair_status_color = color
    isInited.value = true
    Toast.clear()
  } catch (error) {
    commonErrorHandle(error)
  }
  refreshing.value = false
}
async function disAgreeRepairHandle() {
  try {
    await showConfirmModal({
      title: '',
      message: '确认不同意维修方案？',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    await confirmOrderRepair({
      is_agree: 0,
      guid,
    })
    clearToast()
    removeServiceOrderKeepAlive()
    MalfunctionRepairOrderDetailStorage.clear() // 清除缓存
    initPageDetail()
  } catch (error) {
    commonErrorHandle(error)
  }
}
async function confirmRepairHandle() {
  try {
    await showConfirmModal({
      title: '',
      message: '确认维修',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    await confirmOrderRepair({
      is_agree: 1,
      guid,
    })
    clearToast()
    removeServiceOrderKeepAlive()
    MalfunctionRepairOrderDetailStorage.clear() // 清除缓存
    initPageDetail()
  } catch (error) {
    commonErrorHandle(error)
  }
}
const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}

// 判断是否植保机
const isPlant = computed(() => {
  return detail.value?.process_type === 'P_SERIAL'
})
onMounted(() => {
  initPageDetail()
  initClipboard('#copyItem')
})
onActivated(() => {
  removeOrderRepairDetailItemKeepAlive()
})

// initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "维修单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        (isInited.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "status-text",
                  style: _normalizeStyle('color:' + _unref(detail)?.repair_status_color)
                }, _toDisplayString(_unref(detail)?.repair_status_text), 5),
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(" 维修单号：" + _toDisplayString(_unref(detail).repair_sn) + " ", 1),
                  _hoisted_4
                ])
              ]),
              _createVNode(ServiceInfoBlock, {
                detail: qualitativeInfo.value,
                guid: _unref(detail).repair_guid,
                serviceGuid: _unref(serviceGuid),
                repair_sn: _unref(detail).repair_sn,
                serviceNo: _unref(serviceNo),
                isPlant: _unref(isPlant)
              }, null, 8, ["detail", "guid", "serviceGuid", "repair_sn", "serviceNo", "isPlant"]),
              _createVNode(RepairPartsBlock, {
                class: "block-item",
                parts: _unref(mateList),
                show: _unref(isAfterLossAssessment)
              }, null, 8, ["parts", "show"]),
              _createVNode(CellWrap, {
                label: "检测情况",
                style: {"margin-top":"12px"},
                "show-arrow": _unref(isAfterLossAssessment),
                fillColor: "rgba(0,0,0,0.44)",
                onClick: toDecection
              }, {
                "cell-right": _withCtx(() => [
                  (!_unref(isAfterLossAssessment))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 暂无 "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["show-arrow"]),
              _createVNode(RepairBillBlock, {
                class: "block-item",
                show: _unref(isAfterLossAssessment) && _unref(canShowPayBlock),
                payInfo: _unref(detail).pay_order_info,
                "is-show-claims": _unref(isShowClaims)
              }, null, 8, ["show", "payInfo", "is-show-claims"]),
              (_unref(canPay) && !_unref(isAuthWarehouseOrder))
                ? (_openBlock(), _createBlock(OrderInoviceApply, {
                    key: 0,
                    onInit: _unref(invoiceDomInit),
                    invoiceData: _unref(detail)?.invoice_apply || null
                  }, null, 8, ["onInit", "invoiceData"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(BehalfPay, {
      show: behalfPayDialogVisible.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((behalfPayDialogVisible).value = $event)),
      orderNo: confirmPayInfo.value?.pay_order_no || '',
      behalfStatusCheckHandle: behalfStatusCheckHandle.value,
      onPaySuccess: behalfPaySuccessHandle
    }, null, 8, ["show", "orderNo", "behalfStatusCheckHandle"]),
    (_unref(showFooter))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(canConfirmRepair) || (_unref(canPay) && _unref(hasServicePayed)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_unref(canConfirmRepair))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, " * 若对维修方案及估价单有疑问请直接联系维修网点咨询！ "))
                  : _createCommentVNode("", true),
                (_unref(canPay))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(hasServicePayed))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, " * 点击确认支付后。保险服务抵扣部分将在意外机损保障额度中扣除。不足抵扣全部維修费用的需要客户线上支付剩余部分維修费用。 "))
                        : _createCommentVNode("", true),
                      (_unref(isFuselageInsurance))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                            _createTextVNode(" * 请根据意外机损保险理赔政策提供理赔材料。"),
                            _createElementVNode("span", {
                              onClick: toClaimInformation,
                              class: "view-flie"
                            }, "查看我的理赔材料")
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            (_unref(canConfirmRepair))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(canConfirmRepair))
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        square: "",
                        type: "success",
                        class: "xa-vant-button-cancel btn-cancel",
                        onClick: disAgreeRepairHandle
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 不同意维修方案 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button",
                    onClick: confirmRepairHandle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认维修")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_unref(canPay))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_unref(showBehalfBtn))
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        square: "",
                        class: "xa-vant-button pay-behalf",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (beforePayHandle('behalf')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("找人代付")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button pay-self",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (beforePayHandle('half')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认支付")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_12
  ], 64))
}
}

})